import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CommonStyle.css";
import { resetPassword } from "../services/apiService";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const navigate = useNavigate();

  useEffect(() => {
    const t = searchParams.get("token");
    if (t) setToken(t);
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirm) {
      setStatus("Passwords do not match");
      return;
    }

    if (!token) {
      setStatus("Token is missing");
      return;
    }

    const payload = {
      token,
      newPassword
    };
    let res = await resetPassword("auth/reset-password", payload);
    if (res?.data?.success) {
      toast.success(res?.data?.message);
       navigate("/login"); 
    } else {
      toast.error(res?.message);
    }
  };

  return (
    <div className={`dashboard ${sidebarOpen ? "sidebar-open" : ""}`}>
      {/* Header */}
      <header className="dashboard-header">
        <div className="dashboard-header-left">
          <button
            className="menu-toggle"
            aria-label="Toggle sidebar"
            onClick={toggleSidebar}
          >
            <span></span>
          </button>
          <div className="logo">Casual Tech</div>
        </div>
        {/* <div className="dashboard-header-right">
          <span style={{ marginRight: "12px" }}>Hello, User</span>
          <button>Logout</button>
        </div> */}
      </header>

      {/* Mobile overlay */}
      <div className="sidebar-overlay" onClick={toggleSidebar}></div>

      {/* Body */}
      <div className="dashboard-body">
        {/* Sidebar */}
        <aside className="dashboard-sidebar">
          <ul className="sidebar-menu">
            <li className="nav-item">
              <Link to={`/signup`} aria-current="page" className="active">
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Registration
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/login`}
                className="nav-link d-flex align-items-center gap-2 active"
                aria-current="page"
              >
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Login
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={`/dashboard`}
                className="nav-link d-flex align-items-center gap-2 active"
                aria-current="page"
              >
                <svg className="bi">
                  <use xlinkHref="#house-fill" />
                </svg>
                Help
              </Link>
            </li>
          </ul>
        </aside>

        {/* Main */}
        <main className="dashboard-main">
          <div style={{ maxWidth: 400, margin: "40px auto" }}>
            <h2>Reset Password</h2>

            {!token && (
              <div className="alert alert-warning">
                No reset token found in URL. Please use the link sent in email.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={newPassword}
                  required
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>

              <div className="form-group mb-3">
                <label>Confirm New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={confirm}
                  required
                  onChange={(e) => setConfirm(e.target.value)}
                />
              </div>

              <button type="submit" className="btn btn-success">
                Update Password
              </button>
            </form>

            {status && <p className="mt-3">{status}</p>}
          </div>
        </main>
      </div>

      {/* Footer */}
      <footer className="dashboard-footer">
        © 2025 Casual Tech. All rights reserved.
      </footer>
    </div>
  );
};

export default ResetPassword;
